import React, { type FC } from "react";

import { Button } from "~/components/button";

import { DataError } from "../data-error/DataError";
import { useExplorationDrawerState } from "../drawer/use-exploration-drawer-state";
import { Link } from "../link";

export interface ErrorScreenProps {
	error: unknown;
	handleError?: () => void;
	noShadow?: boolean;
}

export const ErrorScreen: FC<React.PropsWithChildren<ErrorScreenProps>> = ({
	handleError,
	error,
	noShadow,
	children,
}) => {
	const explorationDrawer = useExplorationDrawerState();

	return (
		<DataError
			button={
				handleError ? (
					<Button
						className="uppercase"
						data-testid="error-events-screen-retry-button"
						onClick={handleError}
						variant="primary"
					>
						Try Again
					</Button>
				) : undefined
			}
			data-testid="error-events-screen"
			header="Something went wrong"
			noShadow={noShadow}
		>
			Unfortunately, it looks like{" "}
			<Link el="button" onClick={() => explorationDrawer.openErrorDetails({ error })} theme="secondary" type="button">
				something
			</Link>{" "}
			went wrong.
			{children}
		</DataError>
	);
};
